import axios from 'axios';

import {
  CreateAdCampaignRequest,
  AdCampaignResponse,
  AdCampaignsResponse,
  PatchAdCampaignRequest,
  VenueAdCampaignConfigResponse,
} from './types';

const adBookingsServiceApi = axios.create({
  baseURL: process.env.AD_BOOKINGS_URI,
});

export default adBookingsServiceApi;

export const getVenueAdCampaignConfiguration = async (
  venueId: string,
  country: Country,
): Promise<VenueAdCampaignConfigResponse> => {
  const res = await adBookingsServiceApi.get<VenueAdCampaignConfigResponse>(
    `/public/merchant-admin/venues/${venueId}/configuration?country=${country}`,
  );
  return res.data;
};

export const createAdCampaign = async (
  venueId: string,
  campaign: CreateAdCampaignRequest,
): Promise<AdCampaignResponse> => {
  const res = await adBookingsServiceApi.post(`/public/merchant-admin/venues/${venueId}/campaigns`, campaign);
  return res.data;
};

export const getAdCampaigns = async (venueId: string): Promise<AdCampaignsResponse> => {
  const res = await adBookingsServiceApi.get<AdCampaignsResponse>(`/public/merchant-admin/venues/${venueId}/campaigns`);
  return res.data;
};

export const getAdCampaign = async (venueId: string, campaignId: string): Promise<AdCampaignResponse> => {
  const res = await adBookingsServiceApi.get<AdCampaignResponse>(
    `/public/merchant-admin/venues/${venueId}/campaigns/${campaignId}`,
  );
  return res.data;
};

export const patchAdCampaign = async (
  venueId: string,
  campaignId: string,
  campaign: PatchAdCampaignRequest,
): Promise<AdCampaignResponse> => {
  const res = await adBookingsServiceApi.patch(
    `/public/merchant-admin/venues/${venueId}/campaigns/${campaignId}`,
    campaign,
  );
  return res.data;
};

export const stopAdCampaign = async (venueId: string, campaignId: string) => {
  const res = await adBookingsServiceApi.post(`/public/merchant-admin/venues/${venueId}/campaigns/${campaignId}/stop`);
  return res.data;
};

export const startAdCampaign = async (venueId: string, campaignId: string) => {
  const res = await adBookingsServiceApi.post(`/public/merchant-admin/venues/${venueId}/campaigns/${campaignId}/start`);
  return res.data;
};
